
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { User, Bell, Settings, HelpCircle, Share2 } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { useToast } from '@/hooks/use-toast';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { UserLogin } from '@/components/auth/UserLogin';

export const ProfilePage: React.FC = () => {
  const { toast } = useToast();
  const [isLoggedIn, setIsLoggedIn] = useState(false); // This would be replaced with actual auth
  
  const handleAction = (action: string) => {
    toast({
      title: "Coming Soon",
      description: `${action} will be available in a future update!`
    });
  };
  
  if (!isLoggedIn) {
    return (
      <div className="space-y-6">
        <h1 className="text-2xl font-bold mb-6 text-center">Profile</h1>
        
        <div className="py-8">
          <UserLogin />
        </div>
      </div>
    );
  }
  
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold mb-6 text-center">Profile</h1>
      
      <Card>
        <CardContent className="pt-6">
          <div className="flex flex-col items-center">
            <Avatar className="h-20 w-20">
              <AvatarFallback className="bg-fasttrack-purple text-white text-xl">
                FT
              </AvatarFallback>
            </Avatar>
            
            <h2 className="text-xl font-bold mt-4">FastTrack User</h2>
            <p className="text-sm text-muted-foreground">Welcome to FastTrack</p>
            
            <Button
              variant="outline"
              className="mt-4"
              onClick={() => handleAction("Profile editing")}
            >
              Edit Profile
            </Button>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center">
            <Bell size={18} className="mr-2" />
            Notifications
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <Label htmlFor="fasting-reminders">Fasting reminders</Label>
            <Switch id="fasting-reminders" defaultChecked />
          </div>
          
          <div className="flex items-center justify-between">
            <Label htmlFor="milestone-notifications">Milestone notifications</Label>
            <Switch id="milestone-notifications" defaultChecked />
          </div>
          
          <div className="flex items-center justify-between">
            <Label htmlFor="weekly-summaries">Weekly summaries</Label>
            <Switch id="weekly-summaries" defaultChecked />
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center">
            <Settings size={18} className="mr-2" />
            Settings
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <Button
            variant="ghost"
            className="w-full justify-start"
            onClick={() => handleAction("App settings")}
          >
            App Settings
          </Button>
          <Button
            variant="ghost"
            className="w-full justify-start"
            onClick={() => handleAction("Privacy settings")}
          >
            Privacy Settings
          </Button>
          <Button
            variant="ghost"
            className="w-full justify-start"
            onClick={() => handleAction("Terms & Conditions")}
          >
            Terms & Conditions
          </Button>
        </CardContent>
      </Card>
      
      <div className="flex space-x-2 pt-4">
        <Button
          variant="outline"
          className="flex-1"
          onClick={() => handleAction("Help")}
        >
          <HelpCircle size={18} className="mr-2" />
          Help
        </Button>
        
        <Button
          variant="outline"
          className="flex-1"
          onClick={() => handleAction("Share")}
        >
          <Share2 size={18} className="mr-2" />
          Share App
        </Button>
      </div>
    </div>
  );
};
